/**
 * 用 0/1代替true/false
 */

import React from "react";
import { Checkbox } from "antd";
import { isTrue } from "../../../Utils/filter";
import { CheckboxProps } from "antd/es/checkbox";

interface SimpleCheckboxProps
    extends Omit<CheckboxProps, "checked" | "onChange"> {
    value?: "0" | "1";
    onChange?(value?: "0" | "1"): void;
}

export function SimpleCheckbox({
    value,
    onChange,
    ...props
}: SimpleCheckboxProps) {
    const checked = isTrue(value);

    function handleChange(e: any) {
        onChange?.(e.target.checked ? "1" : "0");
    }

    return <Checkbox {...props} checked={checked} onChange={handleChange} />;
}
